import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=025ded49"
import script from "./CreateCoupon.vue?vue&type=script&lang=js"
export * from "./CreateCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports